import moment, { Moment } from "moment";
import clsx from "clsx";

import styles from "./CalendarDate.module.scss";
import InteractiveDiv from "../InteractiveDiv";
import BodyText from "../BodyText";

export type CalendarDateProps = {
  date: Moment;
};

export default function CalendarDate({ date }: CalendarDateProps) {
  const currentMonth = moment();
  const selectedDate = moment();
  const highlightedDates = [moment()];
  const minDate = moment().startOf("month");

  const isOutsideOfMonth = date.month() !== currentMonth.month();
  const isSelectedDate = date.isSame(selectedDate, "date");
  const isToday = date.isSame(moment(), "date");
  const isHighlighted = highlightedDates?.some(hd => date.isSame(hd, "date"));
  const isBeforeMinDate = !!minDate && date.isBefore(minDate, "date");

  const disabled = isOutsideOfMonth || isBeforeMinDate;

  return (
    <InteractiveDiv
      className={clsx(
        styles.dateContainer,
        {
          [styles.outsideOfMonth]: isOutsideOfMonth,
          [styles.selected]: isSelectedDate,
          [styles.beforeMin]: isBeforeMinDate,
          [styles.disabled]: disabled,
        },
        !isSelectedDate && {
          [styles.today]: isToday,
          [styles.highlighted]: !isOutsideOfMonth && !isToday && isHighlighted,
        }
      )}
      disabled={disabled}
    >
      <BodyText as="span">{moment(date).format("D")}</BodyText>
    </InteractiveDiv>
  );
}
